<template>
  <v-card
    outlined
    class="rounded py-3 px-4"
    :class="shadowClass"
    data-testid="teamActivity-card-activity"
  >
    <div class="d-flex justify-space-between">
      <p
        class="text-h5 ma-0 pa-0 font-weight-bold blue-grey--text text--darken-3"
      >
        {{ count }}
      </p>
      <div
        class="d-flex align-center justify-center icon-wrapper"
        :class="color"
      >
        <v-icon v-if="icon" :color="iconColor" size="16">{{ icon }}</v-icon>
        <ImageMedia v-else :defaultImage="isotype" style="width: 16px" />
      </div>
    </div>
    <span
      data-private
      class="text-body-2 blue-grey--text text--darken-2"
      v-snip="2"
      >{{ label }}</span
    >
  </v-card>
</template>

<script>
import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'
import isotype from '@/assets/images/rever-isotype.svg'

export default {
  name: 'ActivityCard',

  components: {
    ImageMedia,
  },

  data() {
    return {
      isotype,
    }
  },

  props: {
    count: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    iconColor: {
      type: String,
    },
    color: {
      type: String,
      required: true,
    },
    leftShadow: Boolean,
  },

  computed: {
    shadowClass() {
      return this.leftShadow ? `shadow-${this.color}` : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.icon-wrapper {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: $color-blue-grey-lighten2;
}
.shadow-blue-grey {
  box-shadow: inset 6px 0 0 0 $color-blue-grey-lighten2 !important;
}

.shadow-blue {
  box-shadow: inset 6px 0 0 0 $color-blue-lighten2 !important;
}

.shadow-orange {
  box-shadow: inset 6px 0 0 0 $color-orange-lighten2 !important;
}

.shadow-purple {
  box-shadow: inset 6px 0 0 0 $color-purple-lighten2 !important;
}
.shadow-teal {
  box-shadow: inset 6px 0 0 0 $color-teal-lighten2 !important;
}
</style>
